import React, { Component } from 'react';
import { Container, Row, Col, Input, Label, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEdit, faPlus, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import CollapseCard from '../CollapseCard/CollapseCard';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../Modal/ConfirmButton';

class NotesCategoriesEditor extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            notesCategories: [],
            selectedParentID: 0,
            selectedCategoryID: 0,
            newDescription: '',
            editingItem: null,
            saving: false,
            error: '',
            debug_message: null,
        };
    }

    componentDidMount() {
        this.getNotesCategories();
    }

    getNotesCategories() {
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                const notesCategories = (results.data || [])
                    .filter(parentCategory => parentCategory.type !== 'Contact');
                this.setState(prevState => {
                    const selectedParentID = prevState.selectedParentID || notesCategories[0]?.ID || 0;
                    return {
                        notesCategories,
                        selectedParentID,
                        selectedCategoryID: this.getSafeListFieldID(notesCategories, selectedParentID, prevState.selectedCategoryID)
                    };
                });
            });
    }

    getListFields = (notesCategories = this.state.notesCategories, parentID = this.state.selectedParentID) => {
        const parentCategory = notesCategories.find(item => item.ID === parentID);
        return (parentCategory?.children || []).filter(childCategory => childCategory.validation === 'list' || childCategory.list != null);
    }

    getSafeListFieldID = (notesCategories, parentID, selectedCategoryID) => {
        const listFields = this.getListFields(notesCategories, parentID);
        if (listFields.some(field => field.ID === selectedCategoryID)) return selectedCategoryID;
        return listFields[0]?.ID || 0;
    }

    onParentChange = (e) => {
        const selectedParentID = parseInt(e.target.value);
        this.setState(prevState => ({
            selectedParentID,
            selectedCategoryID: this.getSafeListFieldID(prevState.notesCategories, selectedParentID, 0),
            newDescription: '',
            editingItem: null,
            error: ''
        }));
    }

    saveChoice = (url, method, body, onSuccess) => {
        this.setState({ saving: true, error: '' });
        fetch(url, {
            method,
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (!results.success) throw new Error(results.error || 'Could not save the choice.');
                this.setState({ saving: false, error: '' });
                onSuccess();
                this.getNotesCategories();
            })
            .catch(error => this.setState({ saving: false, error: error.message }));
    }

    handleCreate = () => {
        const description = this.state.newDescription.trim();
        if (!this.state.selectedCategoryID || !description || this.state.saving) return;
        this.saveChoice('/api/notesCategories/', 'POST', {
            commentTypeId: this.state.selectedCategoryID,
            description
        }, () => this.setState({ newDescription: '' }));
    }

    handleUpdate = () => {
        const item = this.state.editingItem;
        if (!item || !item.description.trim() || !item.longDescription.trim() || this.state.saving) return;
        this.saveChoice('/api/notesCategoryLists/' + item.ID, 'PUT', {
            description: item.description.trim(),
            longDescription: item.longDescription.trim()
        }, () => this.setState({ editingItem: null }));
    }

    handleDelete = (item) => {
        fetch('/api/notesCategoryLists/' + item.ID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(() => this.getNotesCategories())
    }

    render() {
        const listFields = this.getListFields();
        const selectedField = listFields.find(field => field.ID === this.state.selectedCategoryID);

        return (
            <Container fluid>
                <CollapseCard title="Notes Categories" open={false} header="h3">
                    {/* <p className="text-muted">To add or edit Sales Activity dropdown choices, select <strong>Sales Activity</strong> and then <strong>Activity</strong>. Use Add Choice for a new option or the edit button beside an existing option.</p> */}
                    {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                    <Row>
                        <Col md={4}>
                            <Label>Category</Label>
                            <Input
                                type="select"
                                value={this.state.selectedParentID}
                                onChange={this.onParentChange}
                            >
                                {this.state.notesCategories.length === 0 ? (
                                    <option value={0}>No categories</option>
                                ) : this.state.notesCategories.map(parentCategory => (
                                    <option key={parentCategory.ID} value={parentCategory.ID}>
                                        {parentCategory.type}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                        <Col md={4}>
                            <Label>List Field</Label>
                            <Input
                                type="select"
                                value={this.state.selectedCategoryID}
                                onChange={(e) => this.setState({ selectedCategoryID: parseInt(e.target.value, 10), newDescription: '', editingItem: null, error: '' })}
                            >
                                {listFields.length === 0 ? (
                                    <option value={0}>No list fields</option>
                                ) : listFields.map(childCategory => (
                                    <option key={childCategory.ID} value={childCategory.ID}>
                                        {childCategory.type}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row className="font-weight-bold mt-4 mb-2">
                        <Col md={4}>Short Description</Col>
                        <Col md={6}>Long Description (shown in dropdowns and reports)</Col>
                        <Col md={2}></Col>
                    </Row>
                    {(selectedField?.list || []).map(item => (
                        <Row key={item.ID} className='mb-2'>
                            <Col md={4}>{this.state.editingItem?.ID === item.ID
                                ? <Input aria-label="Short Description" value={this.state.editingItem.description} onChange={e => this.setState({ editingItem: { ...this.state.editingItem, description: e.target.value } })} />
                                : item.description}</Col>
                            <Col md={6}>{this.state.editingItem?.ID === item.ID
                                ? <Input aria-label="Long Description" value={this.state.editingItem.longDescription} onChange={e => this.setState({ editingItem: { ...this.state.editingItem, longDescription: e.target.value } })} />
                                : item.longDescription}</Col>
                            <Col md={2} className="text-right">
                                {this.state.editingItem?.ID === item.ID ? <>
                                    <Button color="success" className="mr-1" title="Save choice" onClick={this.handleUpdate} disabled={this.state.saving || !this.state.editingItem.description.trim() || !this.state.editingItem.longDescription.trim()}><FontAwesomeIcon icon={faCheck} /></Button>
                                    <Button color="secondary" title="Cancel editing" onClick={() => this.setState({ editingItem: null, error: '' })}><FontAwesomeIcon icon={faTimes} /></Button>
                                </> : <>
                                    <Button color="primary" className="mr-1" title="Edit choice" onClick={() => this.setState({ editingItem: { ...item, description: item.description || '', longDescription: item.longDescription || '' }, error: '' })}><FontAwesomeIcon icon={faEdit} /></Button>
                                    <ConfirmButton color="danger" onClick={() => this.handleDelete(item)}><FontAwesomeIcon icon={faTrashAlt} /></ConfirmButton>
                                </>}
                            </Col>
                        </Row>
                    ))}
                    {selectedField && <Row className="mt-3 mb-2">
                        <Col md={10}>
                            <Input aria-label="New choice" placeholder="New choice (used for both descriptions)" value={this.state.newDescription} onChange={e => this.setState({ newDescription: e.target.value })} />
                        </Col>
                        <Col md={2} className="text-right">
                            <Button color="success" onClick={this.handleCreate} disabled={this.state.saving || !this.state.newDescription.trim()}><FontAwesomeIcon icon={faPlus} /> Add Choice</Button>
                        </Col>
                    </Row>}
                </CollapseCard>
            </Container>
        );
    };
}

export default NotesCategoriesEditor;
